import React from 'react'
import styled from 'styled-components'

interface Props {
  client: React.ReactNode
  date: React.ReactNode
  extra?: React.ReactNode
  className?: string
}

const OrderHeaderBlock: React.FC<Props> = ({ client, date, extra, className }) => (
  <Wrapper className={className}>
    <Row>
      <ClientCell>{client}</ClientCell>
      <DateCell>{date}</DateCell>
    </Row>
    {extra ? <Extra>{extra}</Extra> : null}
  </Wrapper>
)

export default OrderHeaderBlock

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-bottom: 0.5rem;
  direction: rtl;
`

const Row = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 9.5rem;
  gap: 0.5rem;
  align-items: stretch;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    grid-template-columns: minmax(0, 1fr) 7.5rem;
    gap: 0.375rem;
  }
`

const ClientCell = styled.div`
  min-width: 0;
`

const DateCell = styled.div`
  min-width: 0;
`

const Extra = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`
